import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { TagiDto } from '../modele/tagi';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TagiService {

  private basePHAPIUrl = environment.basePHAPIUrl;

  // Cache
  private tagiCache$?: Observable<TagiDto[]>;

  constructor(private http: HttpClient) {}

  getTagi(): Observable<TagiDto[]> {
    if (!this.tagiCache$) {
      this.tagiCache$ = this.http
        .get<TagiDto[]>(`${this.basePHAPIUrl}/tagi/findAll`)
        .pipe(shareReplay(1));
    }
    return this.tagiCache$;
  }
}
